/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneHeader from 'DesignSystem/TysiaSelectOne/TysiaSelectOneHeader/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/Actions/EditPreferences/Content/Main/Content/Content/ActiveStep/Content",
  onChange,
  isSubmitting
  
}) {
let preferenceValueData = fromData.useDataValue({ viewPath,
context: 'preference',
})
let selectedValueValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'value',
})
let selectedValueChangeData = fromData.useDataChange({ viewPath,
context: 'selected',
path: 'value',
})
let stepsIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'steps',
})
let selectedNameValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'name',
})
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 data="preference"
 from={preferenceValueData}
 data="selected.value"
 value={selectedValueValueData}
 onChange={selectedValueChangeData}
 data="steps"
 disabled={stepsIsSubmittingData}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneHeader
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneHeader`}
>
{childProps => (
<TysiaSelectOneLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 data="selected.name"
 text={selectedNameValueData}
/>
)}
</TysiaSelectOneHeader>
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
</React.Fragment>
)}
</TysiaSelectOne>
{children}
</React.Fragment>)
}